import { isBlank, isEmail } from './lib';

export const notBlankValidator = (value) => ({
  validator: !isBlank(value),
  message: (label) => `Expected ${label} to not be blank.`,
});

export const isValidEmail = (value) => ({
  validator: isEmail(value),
  message: () => 'Please enter a valid email address.',
});
